import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Webhook, ChevronDown, ChevronRight } from "lucide-react";
import { webhooksApi } from "../lib/ledgerApi";

const STATUS_COLOR = {
  succeeded: "border-status-ok/40 bg-status-ok/10 text-status-ok",
  pending: "border-status-info/40 bg-status-info/10 text-status-info",
  delivering: "border-status-info/40 bg-status-info/10 text-status-info",
  failed: "border-amber-500/40 bg-amber-500/10 text-amber-600 dark:text-amber-400",
  exhausted: "border-status-tampered/40 bg-status-tampered/10 text-status-tampered",
};

export default function WebhookDeliveriesCard({ txId }) {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!txId) return;
    let alive = true;
    webhooksApi.deliveriesByTx(txId)
      .then((r) => alive && setItems(r.items || []))
      .catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, [txId]);

  if (items == null) return null;
  if (items.length === 0) return null; // hidden when no deliveries

  return (
    <div className="border border-border rounded-sm bg-card mt-6" data-testid="tx-webhook-deliveries">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-muted/30"
        data-testid="tx-webhook-deliveries-toggle"
      >
        <div className="flex items-center gap-2">
          <Webhook className="w-4 h-4" strokeWidth={1.5} />
          <span className="text-sm">Webhook deliveries</span>
          <span className="text-[11px] text-muted-foreground">({items.length})</span>
        </div>
        {open ? <ChevronDown className="w-4 h-4" strokeWidth={1.5} /> : <ChevronRight className="w-4 h-4" strokeWidth={1.5} />}
      </button>
      {open && (
        <div className="border-t border-border divide-y divide-border">
          {items.map((d) => (
            <Link
              key={d.id}
              to={`/app/webhooks/${d.subscription_id}`}
              className="block p-3 hover:bg-muted/30 grid grid-cols-12 gap-2 items-center text-xs"
              data-testid={`tx-webhook-row-${d.id}`}
            >
              <div className="col-span-5 font-mono truncate">{d.url}</div>
              <div className="col-span-3 font-mono text-[11px]">{d.event_type}</div>
              <div className="col-span-2">
                <span className={`px-2 py-0.5 border rounded-sm text-[10px] uppercase tracking-widest ${STATUS_COLOR[d.status] || "border-border bg-muted/30 text-muted-foreground"}`}>{d.status}</span>
              </div>
              <div className="col-span-2 text-[10px] text-muted-foreground text-right">{d.scheduled_at ? new Date(d.scheduled_at).toLocaleString() : "—"}</div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
